import { SvgIconProps } from '@mui/material';
import React from 'react';
import CheckCircle from '../../icons/check-circle.svg';
import { Icon } from './Icon';

/**Success Check */
export function SuccessIcon(props: SvgIconProps) {
  return <Icon data-cy="successIcon" glyph={CheckCircle} {...props} />;
}
